var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvailable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.1548 81.8184C33.8704 81.8184 18.1816 66.1296 18.1816 46.8452C18.1816 27.5608 33.8704 11.8711 53.1548 11.8711C72.4392 11.8711 88.1289 27.5599 88.1289 46.8443C88.1289 66.1286 72.4392 81.8184 53.1548 81.8184ZM53.1548 15.2105C35.7116 15.2105 21.521 29.401 21.521 46.8443C21.521 64.2875 35.7116 78.478 53.1548 78.478C70.598 78.478 84.7886 64.2875 84.7886 46.8443C84.7886 29.401 70.598 15.2105 53.1548 15.2105Z",
    fill: "#00CC60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3727 64.1023L31.8627 49.5922L37.0832 44.3717L46.3727 53.6622L69.8372 30.1978L75.0577 35.4183L46.3727 64.1023Z",
    fill: "#00CC60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailable);
export default __webpack_public_path__ + "static/media/available.626024b440cc506dce75b17dc453c61b.svg";
export { ForwardRef as ReactComponent };